module.exports = __webpack_public_path__ + "img/img6.8aedeab3.png";